import { arrayBufferToBase64Url } from './webAuthn';

/** User handle stored in the passkey: UTF-8 bytes of the user id, base64url. */
export function passkeyUserHandle(userId) {
  return arrayBufferToBase64Url(new TextEncoder().encode(String(userId)));
}

/**
 * Tell the browser which passkeys are still accepted so it can hide revoked
 * ones. Call only after the user is authenticated. Calling this before the
 * sign-in prompt races with the assertion and is outside the WebAuthn Signal
 * API contract. Browsers without the API are skipped. Failures are ignored.
 */
export async function signalAcceptedPasskeys({ rpId, userId, credentialIds }) {
  const signal = globalThis.PublicKeyCredential?.signalAllAcceptedCredentials;
  const ids = (credentialIds || []).filter(Boolean);
  if (typeof signal !== 'function' || !rpId || !userId || ids.length === 0) {
    return;
  }
  try {
    await signal.call(globalThis.PublicKeyCredential, {
      rpId,
      userId: passkeyUserHandle(userId),
      allAcceptedCredentialIds: ids,
    });
  } catch {
    // Sign-in continues when the browser cannot apply the signal.
  }
}
